import { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import {
  showMessage,
  makeAjax,
  url,
  respStatus,
  alternativeSiteOperation,
} from "../../../helpers/global_helper";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { getPlayerProfileDetail } from "../../../store/actions";
import { checkPinStatus } from "../../../store/check-pin-status/actions";
import ActionLoader from "../../../pages/ActionLoader";
import Popup from "../Popup";
import { getSocialMediaFingerPrint } from "../../../pages/SocialMediaFingerPrint";
import Cookies from "js-cookie";
const LoginPopup = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { pinStatus, redirect } = useSelector((state) => ({
    pinStatus: state.checkPinStatusR?.data ?? {},
    redirect: state.checkPinStatusR?.redirect ?? {},
  }));
  const { componentSetting } = useSelector((state) => ({
    componentSetting: state.componentSettingListR.data,
  }));
  const [isPopup, setIsPopup] = useState(false);
  const [globalMaintenance, setGlobalMaintenance] = useState(false);
  const [loaderStatus, setLoader] = useState(false);
  const [showRegisterpopup, setShowRegisterpopup] = useState(false);
  const [userDataHandleClick, setUserDataHandleClick] = useState(false);
  const [getClient, setGetClient] = useState([]);

  const handlePopup = () => {

    setGlobalMaintenance(false);
    props.handle();
  };
  const HandleRegisterPopup = () => {
    setShowRegisterpopup(!showRegisterpopup);
    setIsPopup(false);
  };
  const userDataHandle = () => {
    setUserDataHandleClick(true);
  };
  const [formError, setFormError] = useState({});

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    key: ""
  });

  const [errors, setErrors] = useState({});

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setFormData((values) => ({ ...values, [name]: value }));
    setErrors((values) => ({ ...values, [name]: null }));
    setFormError({ ...formError, [name]: "" });
  };

  const redirectMe = (pinStatus, path, component_location) => {
    console.log('redirectMe', pinStatus, path);
    let config_status = pinStatus.get_tenant_config?.value;
    let url = "";
    if (
      config_status === true &&
      pinStatus.enabled_active_pin === true &&
      pinStatus.active_pin === false
    ) {
      url = "/login-pin";
    } else if (
      config_status === true &&
      pinStatus.enabled_active_pin === true &&
      pinStatus.is_pin_verified === false
    ) {
      url = "/security-validation";
    } else if (
      pinStatus.is_security_question_set === false ||
      pinStatus.is_security_question_set === null
    ) {
      url = "/security-question";
    } else if (pinStatus.is_password_active === false) {
      url = "/reminder-password";
    } else {
      let deviceType = window.localStorage.getItem("device_type");
      if(deviceType === 'mobile'){
        props.handle();
      }
      props.userData();
      return;
    }
    navigate(url);
    props.handle();
    props.userData();
  };

  useEffect(() => {
    console.log('pinStatus', pinStatus);
    if (Object.keys(pinStatus).length)
      redirectMe(pinStatus, location.pathname, "/");
  }, [pinStatus]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoader(true);
    formData['device_finger_print'] = await getSocialMediaFingerPrint();
    makeAjax(url.USER_API.login, formData, url.USER_MS_EXT).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        setLoader(false);
        if (response.code == "loginMaintenanceOn") {
          let msg = response.messages[0];
          if (response.data) {
            msg = response.data;
          }
          setGlobalMaintenance(msg);
          return;
        }
        if (response.code !== "validation_error") {
          showMessage(response);
        }
        setFormError(response.messages);
        return;
      }
      let my_token = response.data.token;
      localStorage.setItem("isLoggedIn", true);
       const gameWindowData = Cookies.get("gameWindow") ? JSON.parse(Cookies.get("gameWindow")) : null;
      const existingWindow = window.open("", gameWindowData?.id);
      if (existingWindow) {
        existingWindow.close();
    }
      Cookies.remove("gameWindow");
      localStorage.setItem("user_token", my_token);
      let ret = alternativeSiteOperation('is_login');
      if (!ret) {
        dispatch(getPlayerProfileDetail());
        dispatch(checkPinStatus());
        if (['/register'].includes(location.pathname))
          navigate("/");
        setLoader(false);
      }
      // navigate(0)
    });
  };

  const handleClose = () => {
    props.handle();
  };

  const [inputType, setInputType] = useState(false);

  const toggleEye = () => {
    setInputType((curr) => !curr);
  };

  const { playerMenu } = useSelector((state) => ({
    playerMenu: state.menuListR.data,
  }));

  // added 15th 2024
  useEffect(() => {
    getClientDetails();
  }, [location])

  const getClientDetails = (event) => {
    makeAjax(url.ADMIN_API.getClientDetails, formData, url.ADMIN_MS_EXT)
      .then(response => {
        if (response.status != respStatus['SUCCESS']) {
          if (response.code != 'validation_error') {
            // showMessage(response);
          }
          setFormError(response.messages);
          return;
        }
        setGetClient(response.data);
      })
  }

  return (
    <div className="login-popup">
      {/* <h2 className="title">{props.t('login')}</h2> */}
      <form onSubmit={handleSubmit}>
        <div className="input-control">
          <label className="form-label text-form_text">{props.t("username")}</label>
          <input
            type="text"
            placeholder={props.t("enter_username")}
            name="username"
            onChange={handleChange}
          />
          {formError.username ? (
            <span className="text-danger">{formError.username[0]}</span>
          ) : null}
        </div>
        <div className="input-control">
          <div className="password-icon">
            <label className="form-label text-form_text">{props.t("password")}</label>
            <input
              type={inputType == true ? "text" : "password"}
              placeholder={props.t("password")}
              name="password"
              onChange={handleChange}
            />
            {inputType == true ? (
              <AiOutlineEye onClick={toggleEye} ref={props.btnRefLoginEye} />
            ) : (
              <AiOutlineEyeInvisible onClick={toggleEye} />
            )}
            {formError.password ? (
              <span className="text-danger">{formError.password[0]}</span>
            ) : null}
          </div>
        </div>
        <div className="d-flex align-items-center login-footer">
          <NavLink
            to="forgot-password"
            className="forgot-pass"
            onClick={handleClose}
          >
            {props.t("forgot_password")} ?
          </NavLink>
          {getClient?.is_external &&
            <div>
              {/* <NavLink
                className="customer-complaint"
                onClick={() => setIsPopup((curr) => !curr)}
              >
                {props.t("customer_complaint")}
              </NavLink> */}
            </div>
          }
        </div>
        <div className="login-btns">
          {/* {playerMenu.before &&
            playerMenu.before.register &&
            playerMenu.before.register.status ? (
            <div>
              {
                componentSetting?.["top-nav-register-box"]?.["default-value"] == "popup" &&
                <NavLink className="register" onClick={HandleRegisterPopup}>
                  {props.t(`${playerMenu.before.register.code}`)}
                </NavLink>
              }
              {
                componentSetting?.["top-nav-register-box"]?.["default-value"] == "inline" &&
                <NavLink to={"register"} className="register" onClick={handleClose} >
                  {props.t(`${playerMenu.before.register.code}`)}
                </NavLink>
              }
            </div>

          ) : null} */}
          <div>
            {
              componentSetting?.["top-nav-register-box"]?.["default-value"] == "popup" &&
              <NavLink className="register text_button-register border-register background-register_button" onClick={HandleRegisterPopup}>
                {props.t('register')}
              </NavLink>
            }
            {
              componentSetting?.["top-nav-register-box"]?.["default-value"] == "inline" &&
              <NavLink to="register" className="register text_button-register border-register background-register_button" onClick={handleClose} >
                {props.t('register')}
              </NavLink>
            }
          </div>
          <ActionLoader
            label={"login"}
            loaderClass={"login-loader  text_button-login border-login"}
            showLoader={loaderStatus}
            onClick={handleSubmit}
          />
        </div>
      </form>
      {showRegisterpopup && (
        <div className="register-popup">
          <Popup
            handlePoup={HandleRegisterPopup}
            registerpopup
            userDataHandle={userDataHandle}
          />
        </div>
      )}
      {isPopup && <Popup handlePoup={handlePopup} custComplaint />}
      {
        globalMaintenance && (
          <Popup
            handlePoup={handlePopup}
            globalMaintenanceCondition
            message={globalMaintenance}
          />
        )
      }
    </div>
  );
};

LoginPopup.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(LoginPopup);
